@if (!currentState){
<span>Cargando...</span>
} @else {
<div class="py-4">
  <app-logo-header></app-logo-header>
</div>

<div class="w-full">
  <!-- Vista principal: Detección de cuenta -->
  <h1
    class="text-xl font-semibold text-gray-900 mb-6 leading-tight fs-condensed tracking-wide"
  >
    Tenemos una cuenta asociada a tu número de teléfono
  </h1>

  <ng-container *ngTemplateOutlet="userInfoCard"></ng-container>

  @if (!otpSent()) {
  <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
  } @else {
  <div class="pt-2">
    <app-otp-block
      [length]="4"
      instructionText="Hemos enviado un código de 4 dígitos al correo que tienes registrado. Escríbelo a continuación para continuar con tu perfil."
      bottomText="Al verificar, aceptas fusionar tu cuenta actual con el perfil digital encontrado, consolidando tus datos y beneficios."
      [resendTimer]="countdown()"
      (onResendCode)="sendOtp()"
      [isLoading]="isProcessingRegister()"
      (onSubmit)="unirCuentas($event)"
      submitLabel="CREAR CUENTA"
    ></app-otp-block>
    <div class="mx-auto mt-4 w-fit">
      <button
        type="button"
        class="text-sm text-appPrimary-500 hover:text-appPrimary-600 transition-colors w-fit"
        (click)="mostrarOpciones()"
        aria-label="Volver"
      >
        Volver
      </button>
    </div>
  </div>
  }
</div>

<ng-template #userInfoCard>
  <div
    class="bg-white rounded-lg shadow-sm border border-gray-200 p-5 mb-5 w-full space-y-3"
  >
    <div class="flex items-center">
      <div class="w-5 h-5 mr-2 flex-shrink-0">
        <svg
          class="w-5 h-5 text-gray-600"
          fill="currentColor"
          viewBox="0 0 20 20"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
      <span class="text-gray-900 opacity-75 font-medium text-sm">{{
        currentState.foundPhoneData?.nombrePreferido
      }}</span>
    </div>

    @if (!otpSent()) {
    <div class="flex items-center">
      <div class="w-5 h-5 mr-2 flex-shrink-0">
        <svg
          class="w-5 h-5 text-gray-600"
          fill="currentColor"
          viewBox="0 0 20 20"
          aria-hidden="true"
        >
          <path
            d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
          />
          <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
        </svg>
      </div>
      <span class="text-gray-600 text-sm">{{
        currentState.foundPhoneData?.email
      }}</span>
    </div>

    <div class="flex items-center">
      <div class="w-5 h-5 mr-2 flex-shrink-0">
        <svg
          class="w-5 h-5 text-gray-600"
          fill="currentColor"
          viewBox="0 0 20 20"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
      <span class="text-gray-500 text-sm"
        >Último inicio:
        {{
          formatLastLogin(currentState.foundPhoneData?.ultimoInicioSesion)
        }}</span
      >
    </div>
    }
  </div>
</ng-template>

<ng-template #actionButtons>
  <div class="space-y-4 w-full">
    <button
      class="fs-condensed w-full bg-allasRed hover:bg-allasRed-500 text-white font-medium py-2.5 px-4 rounded-lg transition-colors text-md"
      [ngClass]="{
        'bg-gray-300 text-gray-500 cursor-not-allowed': isProcessingRegister() || otpSent(),
      }"
      (click)="sendOtp()"
      [disabled]="isProcessingRegister() || otpSent()"
      aria-label="Confirmar que son mis datos y continuar"
    >
      SÍ SON MIS DATOS, CONTINUAR
    </button>
    <button
      class="fs-condensed w-full font-medium py-2.5 px-4 rounded-lg transition-colors text-md bg-gray-200 hover:bg-gray-300 text-gray-700"
      (click)="reemplazarCuenta()"
      [disabled]="isProcessingRegister() || otpSent()"
      [ngClass]="{
        'bg-gray-300 text-gray-500 cursor-not-allowed': isProcessingRegister() || otpSent(),
      }"
      aria-label="Crear cuenta nueva"
    >
      @if (isProcessingRegister()) {
      <span class="flex items-center justify-center" aria-hidden="false">
        <app-loading-spinner size="sm"></app-loading-spinner>
        NO SON MIS DATOS, CREAR CUENTA NUEVA
      </span>
      } @else {
      <span aria-hidden="false">NO SON MIS DATOS, CREAR CUENTA NUEVA</span>
      }
    </button>
  </div>
</ng-template>
}
